var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M12,3.61a.546.546,0,0,0-.16-.386L8.774.158A.546.546,0,0,0,8,.158L3.994,4.167a3.5,3.5,0,0,0-3.834.462.546.546,0,0,0,0,.771L2.993,8.234.447,10.779a.545.545,0,0,0,.771.771L3.764,9.005,6.6,11.839a.545.545,0,0,0,.771,0A3.5,3.5,0,0,0,7.831,8L11.84,4A.546.546,0,0,0,12,3.61M6.8,7.494a.545.545,0,0,0-.108.617,3.056,3.056,0,0,1,.222,2.5L4.15,7.848h0L1.388,5.086a3.056,3.056,0,0,1,2.5.222A.545.545,0,0,0,4.5,5.2L8.388,1.315,10.683,3.61Z",
    transform: "translate(0 0.001)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pin_light.634ad4f325510b965ffb4effe96a4bd2.svg";